import { useFullInclusionTravelPeriodFilter } from 'hooks/useFullInclusionTravelPeriodFilter'
import moment from 'moment/moment'

export function useOfferInclusions(
  pkg: App.Package,
  checkIn?: moment.Moment,
  checkOut?: moment.Moment,
): { inclusions: App.PackageInclusion[], bonusInclusions: App.PackageInclusion[], tacticalInclusions: App.PackageInclusion[] } {
  const commonInclusions = useFullInclusionTravelPeriodFilter(pkg.inclusions ?? [], checkIn, checkOut)
  const bonusInclusions = useFullInclusionTravelPeriodFilter(pkg.bonusInclusions ?? [], checkIn, checkOut)
  const tacticalInclusions = [...commonInclusions.filter(inclusion => inclusion.hasTactical), ...bonusInclusions.filter(inclusion => inclusion.hasTactical)]
  return {
    inclusions: commonInclusions.filter(inclusion => !inclusion.hasTactical),
    bonusInclusions: bonusInclusions.filter(inclusion => !inclusion.hasTactical),
    tacticalInclusions,
  }
}
